// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/components/NavBar/styles.scss
// module id = 1224
// module chunks = 0